import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";

import { dummyProduct } from "../../consts/products";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ProductBump extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initButton = (preview) => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;
    const settings = this.props?.settings;

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");
    const priceSettings = settings["price_color"];
    const oldPriceColor = settings["old_price_color"];

    let {
      showProductPrices,
      productPriceBgColor,
      productPriceColor,
      showReductionLabel,
      reductionLabelBgColor,
      reductionLabelColor,
      showAddToCart,
      addToCartBgColor,
      addToCartColor,
    } = payload.datas || {
      showProductPrices: null,
      productPriceBgColor: null,
      productPriceColor: null,

      showReductionLabel: null,
      reductionLabelBgColor: null,
      reductionLabelColor: null,

      showAddToCart: null,
      addToCartBgColor: null,
      addToCartColor: null,
    };

    const finalPrice = dummyProduct.price["reduced-price"]
      ? dummyProduct.price["reduced-price"]
      : dummyProduct.price["old-price"];
    const finalPriceInt = finalPrice.replace("$", "");

    const demoBundleProduct = {
      name: dummyProduct.name,
      image: dummyProduct.image,
      price: finalPrice,
      percent: 30,
      reduced_price: finalPriceInt - finalPriceInt * 30 * 0.01,
      reduction_price: finalPriceInt * 30 * 0.01,
    };

    let reductionLabel = payload.datas["reductionLabel"] || "";
    let addToCartLabel01 = payload.datas["addToCartLabel01"] || "";
    let addToCartLabel02 = payload.datas["addToCartLabel02"] || "";

    if (payload.datas) {
      if (payload.datas["reductionLabel_" + this.props.currentLang])
        reductionLabel =
          payload.datas["reductionLabel_" + this.props.currentLang];

      if (payload.datas["addToCartLabel01_" + this.props.currentLang])
        addToCartLabel01 =
          payload.datas["addToCartLabel01_" + this.props.currentLang];

      if (payload.datas["addToCartLabel02_" + this.props.currentLang])
        addToCartLabel02 =
          payload.datas["addToCartLabel02_" + this.props.currentLang];
    }

    if (reductionLabel) {
      reductionLabel = reductionLabel.replace(
        "%REDUCTION_PERCENT%",
        demoBundleProduct.percent + "%"
      );
      reductionLabel = reductionLabel.replace(
        "%REDUCTION_PRICE%",
        "$" + demoBundleProduct.reduction_price
      );
      reductionLabel = reductionLabel.replace(
        "%REDUCED_PRICE%",
        "$" + demoBundleProduct.reduced_price
      );
    }

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol" style={cssSettingsText}>
            <div className="bundle-main-container container-fluid">
              <div className="overlay"></div>
              {(demoBundleProduct && demoBundleProduct.name && (
                <div className="row offer-box first">
                  <div className="col-sm-6">
                    <div className="product-img">
                      {dummyProduct.image && (
                        <img src={dummyProduct.image} alt="product" />
                      )}
                      {showProductPrices && dummyProduct.price && (
                        <span
                          className="price-txt"
                          style={{
                            backgroundColor: productPriceBgColor || "#000",
                            color:
                              productPriceColor ||
                              priceSettings?.color ||
                              "#FFF",
                          }}
                        >
                          {dummyProduct.price["reduced-price"]
                            ? dummyProduct.price["reduced-price"]
                            : dummyProduct.price["old-price"]}
                        </span>
                      )}
                    </div>
                    <div className="product-info">
                      <div className="product-name" style={cssSettingsText}>
                        {dummyProduct.name}
                      </div>
                      <div className="attrlist">
                        <div className="selectbox">
                          <select
                            name="group_1"
                            className="attrs-list form-control group_1"
                          >
                            <option value="8" title="Purple" className="">
                              Purple
                            </option>
                          </select>
                        </div>
                        <div className="selectbox">
                          <select
                            name="group_2"
                            className="attrs-list form-control group_2"
                          >
                            <option value="9" title="China" className="">
                              China
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="product-img">
                      {demoBundleProduct.image && (
                        <img src={demoBundleProduct.image} alt="product" />
                      )}
                      {showProductPrices && demoBundleProduct.price !== "" && (
                        <span
                          className="price-txt"
                          style={{
                            backgroundColor: productPriceBgColor || "#000",
                            color:
                              productPriceColor ||
                              priceSettings?.color ||
                              "#FFF",
                          }}
                        >
                          {demoBundleProduct.price}
                        </span>
                      )}
                    </div>
                    <div className="product-info">
                      <div className="product-name" style={cssSettingsText}>
                        {demoBundleProduct.name}
                      </div>
                      <div className="attrlist">
                        <div className="selectbox">
                          <select
                            name="group_1"
                            className="attrs-list form-control group_1"
                          >
                            <option value="8" title="Purple" className="">
                              Purple
                            </option>
                          </select>
                        </div>
                        <div className="selectbox">
                          <select
                            name="group_2"
                            className="attrs-list form-control group_2"
                          >
                            <option value="9" title="China" className="">
                              China
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )) ||
                (!preview && (
                  <div className="row offer-box first">
                    <div className="col-sm-6">
                      <div className="product-img">
                        <Skeleton width={250} height={250} />
                        <span className="price-txt price-skeleton">
                          <Skeleton width={50} height={30} />
                        </span>
                      </div>
                      <div className="product-info">
                        <div className="product-name">
                          <Skeleton height={26} />
                        </div>
                        <div className="attrlist">
                          <div className="selectbox">
                            <Skeleton height={40} />
                          </div>
                          <div className="selectbox">
                            <Skeleton height={40} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="product-img">
                        <Skeleton width={250} height={250} />
                        <span className="price-txt price-skeleton">
                          <Skeleton width={50} height={30} />
                        </span>
                      </div>
                      <div className="product-info">
                        <div className="product-name">
                          <Skeleton height={26} />
                        </div>
                        <div className="attrlist">
                          <div className="selectbox">
                            <Skeleton height={40} />
                          </div>
                          <div className="selectbox">
                            <Skeleton height={40} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              <div className="row offer-box">
                <div className="col-md-12">
                  {(showReductionLabel && reductionLabel && (
                    <div
                      className="save-txt"
                      style={{
                        backgroundColor: reductionLabelBgColor || null,
                        color:
                          reductionLabelColor ||
                          cssSettingsText?.color ||
                          "#000",
                        size: cssSettingsText.size || 27,
                      }}
                    >
                      <span className="line">{reductionLabel}</span>
                    </div>
                  )) || (
                    <div>
                      <Skeleton width={250} height={50} />
                    </div>
                  )}
                  <br />
                  {(showAddToCart &&
                    (addToCartLabel01 || addToCartLabel02) && (
                      <button
                        className="btn claim-offer-btn"
                        style={{
                          backgroundColor: addToCartBgColor || "#000",
                          color: addToCartColor || "#FFF",
                        }}
                      >
                        {addToCartLabel01 && <span>{addToCartLabel01}</span>}
                        {addToCartLabel02 && <span>{addToCartLabel02}</span>}
                      </button>
                    )) || (
                    <div>
                      <Skeleton width={250} height={50} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initButton(true)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initButton()}
      </Draggable>
    );
  }
}

ProductBump.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductBump);
